module.exports = __webpack_public_path__ + "assets/images/plan_bg@2x-4e7758b0a325e92332e4a0d2612220b6.jpg";